// Exactly one opening variation: what the openings screen's rows link with.
import { text, type FilterCriterion } from '../criterion.ts';
import { foldOpening, openingVariationOf } from '../openings.ts';

/** No control of its own: the opening field shows and replaces it. */
export const variation: FilterCriterion<'variation'> = {
  key: 'variation',
  query: 'variation',
  ...text,
  matches: (game, v) => {
    const found = game.pgn ? openingVariationOf(game.pgn) : undefined;
    return !!found && foldOpening(found) === foldOpening(v);
  },
};
